import React, { ReactElement, useMemo, useState } from "react";
import Select from "react-select";
import { Loading } from "../ui";
import { LeadService } from "./LeadService";

interface IProps {
	handleChange: (selectedStatus: any, actionType: any) => any;
	defaultValue?: any;
}

export const LeadStatusSelect = (props: IProps): ReactElement => {
	const [statuses, setStatuses] = useState<any>([]);

	const leadService = new LeadService();

	useMemo(() => {
		const fetchStatuses = async () => {
			const statusData = await leadService.fetchStatuses();
			setStatuses(statusData);
		};

		fetchStatuses();
	}, []);

	if (!statuses || !statuses.length) {
		return <Loading />;
	}

	const options = statuses.map((status: any) => {
		return {
			value: status.id,
			label: status.name,
		};
	});

	return (
		<Select
			{...props}
			options={options}
			isMulti={false}
			isClearable={false}
			onChange={(selectedStatus: any, actionType: any) => {
				props.handleChange(selectedStatus, actionType);
			}}
		/>
	);
};
